import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IFooterBranding } from 'src/app/api/modules/core/components/static/IFooterBranding';
import { ImageComponent } from '../../../dynamic/components/image/image.component';
import { AbstractLinkComponent } from '../../abstract/abstract-link/abstract-link.component';

/**
 * The Footer Branding Component is used within a Footer.
 * It usually says "DigitaService by Drimify" although the content is open to change.
 */
@Component({
  selector: 'app-footer-branding',
  templateUrl: './footer-branding.component.html',
  styleUrls: ['./footer-branding.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AbstractLinkComponent, ImageComponent],
})
export class FooterBrandingComponent {
  /**
   * The Configuration required for this component to function.
   *
   * Nothing renders until a truthy config arrives.
   */
  readonly config = input<IFooterBranding | null>();
}
